import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {Photo} from '../../../core/entities/photo/photo.entity';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PhotoService {
  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  public uploadPhotos(
    bookingId: number,
    photos: File[]
  ): Observable<Photo[]> {
    const formData = new FormData();

    const data = {
      bookingId
    };

    formData.append('data', JSON.stringify(data));
    if (photos) {
      photos.forEach(f => formData.append('images[]', f, f.name));
    }

    return this.http.post<Photo[]>(`${environment.apiUrl}/manage/photo`, formData).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error(`Uploading photos to booking ${bookingId} failed`, error);
        return throwError(() => error);
      })
    );
  }

  public deletePhoto(
    id: number
  ): Observable<null> {
    return this.http.delete<null>(`${environment.apiUrl}/manage/photo/${id}`).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('PhotoService.deletePhoto failed', error);
        return throwError(() => error);
      })
    );
  }
}
